export default "/images/vendor/flag-icon-css/flags/4x3/fj.svg?ff919dfd6a29444f17e8c019a47a408f";